module.exports = __webpack_public_path__ + "static/img/9570_phase_function_Paper_PointsHejduk_Prediction.3a02249.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/9570_phase_function_Paper_PointsHejduk_Prediction.png
// module id = FJg3
// module chunks = 0